module.exports = __webpack_public_path__ + "img/exercism-brackets-comment.30150565.jpg";